import { PositionGeocode } from '@/domain/position-geocode/position-geocode.entity';
import {
  TourEventType,
  TourEventTypeValues,
} from '@/domain/project-tour-ontour/entities/project-tour-ontour-event.entity';

export type TourEventsFormValues = {
  tourEvents: TourEventFormValues[];
};

export type TourEventFormValues = {
  name: string;
  date: string;
  position: PositionGeocode | undefined;
  capacity: number;
  type: TourEventType;
};

export const defaultTourEventFormValues: TourEventFormValues = {
  name: '',
  date: '',
  position: undefined,
  capacity: 200,
  type: 'venue',
};

export const typeOptions = TourEventTypeValues.filter((acc) => acc !== '');
